import update from 'immutability-helper'
import { CaseSchema, SwitchStepSchema } from '@feedyou/schema'
import { Mutable } from '@feedyou/utils'

import { Action, actionTypes } from './actions'
import { generateId } from '../../../lib/generateId'

export function switchReducer(state: Mutable<SwitchStepSchema>, action: Action) {
  switch (action.type) {
    case actionTypes.SET_CASE:
      if (action?.payload?.id) {
        return {
          ...state,
          cases: state.cases.map((item: CaseSchema) =>
            item.id === action?.payload?.id ? { ...item, ...action.payload } : item
          )
        }
      }

      if (!state.cases) {
        state.cases = []
      }

      return { ...state, cases: [...state.cases, { ...action.payload, id: generateId.stepId() }] }

    case actionTypes.SET_DEFAULT: {
      return {
        ...state,
        default: { ...state.default, ...action.payload, id: `${generateId.stepId()}-default` }
      }
    }

    case actionTypes.DELETE_DEFAULT: {
      const { default: defaultCase, ...restStep } = state
      return restStep
    }

    case actionTypes.SET_CASE_DIALOG:
      return {
        ...state,
        cases: state.cases.map((caseItem: CaseSchema) =>
          caseItem.id === action?.payload?.caseId
            ? { ...caseItem, dialog: action?.payload?.dialogId }
            : caseItem
        )
      }

    case actionTypes.DELETE_CASE:
      return update(state, { cases: { $removeById: action.payload } as any })

    case actionTypes.SET_CONDITION:
      return {
        ...state,
        ...action.payload
      }

    default:
      return state
  }
}
